export default function TermsOfService() {
  window.location.replace("/pdf/boreas_terms_of_service_7_2024.pdf");
}
